module.exports = __webpack_public_path__ + "new_buildings_x.b879f734f09178d8145b6671c75593e1.jpg";